import { Box, StepButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InvestNowStepper from '../ui/investNowStepper';

import Step from '@mui/material/Step';
import StepContent from '@mui/material/StepContent';
import Stepper from '@mui/material/Stepper';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { changeStep, completeFormStep, resetSteps } from '../../features/formStepper.slice';
import { updateStep } from '../../features/stepper.slice';
import {
  createSecureProcess,
  createSubmition,
  getSubmition,
  resetSubmition,
  saveSubmition,
  updateSubmition,
} from '../../features/submition/submition.slice';
import { Report, ReportPageView } from '../../libs/loggers';
import { useTitle } from '../../providers/titleProvider';
import SaveProcess from '../dialogs/saveProcess';
import ContactInfo from '../formSections/ContactInfo';
import BankingDetails from '../formSections/bankingDetails';
import BeneficiariesNominations from '../formSections/beneficiariesNominationsDetails';
import InvestmentDetails from '../formSections/investementDetails';
import PersonalDetails from '../formSections/personDetails';
import RegularWithdrawalsDetails from '../formSections/regularWithdrawalsDetails';
import RequiredDocumentation from '../formSections/requiredDocumentation';
import ReviewAndSubmit from '../formSections/reviewAndSubmit';
import TaxResidencySelfCerificationDetails from '../formSections/taxResidencySelfCertifDetails';
import { resetData } from '../../features/data/data.slice';
import { resetUser } from '../../features/user/user.slice';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: 1,
    },
    overflow: 'hidden',
  },
}));

function Details() {
  const dispatch = useDispatch();
  const thisStep = useSelector((state) => state.stepper.value.steps[3]);
  const navigate = useNavigate();
  const [extendedForm, setExtendedForm] = useState(false);
  const { setTitle } = useTitle();
  const stepper = useSelector((state) => state.stepper.value);
  const [exit, setExit] = useState(false);
  const [isRaHelp, setIsRaHelp] = useState(false);
  const [isBciApplication, setIsBciApplication] = useState(false);
  const [isApexRihfOrQihf, setIsApexRihfOrQihf] = useState(false);

  const [saveProcess, setSaveProcess] = useState(false);
  const data = useSelector((state) => state.data.value);
  const userId = useSelector((state) => state.submition.data?.userId);
  const submitionId = useSelector((state) => state.submition.submition?.submitionId);
  const submitionData = useSelector((state) => state.submition.data);
  const formStepper = useSelector((state) => state.formStepper.value);
  const formStepperSteps = useSelector((state) => state.formStepper.value.formSectionsSteps);

  const classes = useStyles();
  let page = window.location.pathname.replace(/^\/|\/$/g, '');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      submitionData &&
      submitionData.requireHelp &&
      data &&
      data.vehicle === 'Retirement Annuity'
    ) {
      setIsRaHelp(true);
    }
  }, [submitionData, data]);

  useEffect(() => {
    let page = window.location.pathname.replace(/^\/|\/$/g, '');
    ReportPageView(page, userId, submitionId);
  }, [submitionId, userId]);

  //Register Controls
  useEffect(() => {
    setTitle('Investor Details');
  }, [setTitle]);

  useEffect(() => {
    if (
      submitionData?.funds?.some(
        (fund) => fund?.fund?.formSlug === 'bci_individual_investor_application'
      )
    ) {
      setIsBciApplication(true);
    } else {
      setIsBciApplication(false);
    }
  }, [submitionData]);

  useEffect(() => {
    if (!exit) {
      if (submitionId) {
        dispatch(getSubmition(submitionId));
      }
    }
  }, [submitionId, exit, dispatch]);

  useEffect(() => {
    if (
      submitionData?.funds?.some(
        (fund) =>
          fund?.fund?.formSlug === 'apex_rihf_investor_application' ||
          fund?.fund?.formSlug === 'apex_qihf_investor_application'
      )
    ) {
      setIsApexRihfOrQihf(true);
    } else {
      setIsApexRihfOrQihf(false);
    }
  }, [submitionData]);

  useEffect(() => {
    if (data.funds) {
      // eslint-disable-next-line array-callback-return
      data.funds.map((fund) => {
        if (fund.fund.extendedForm && !extendedForm) {
          setExtendedForm(true);
        }
      });
    }
  }, [data.funds, extendedForm]);

  const openSave = (data) => {
    const eventInfo = {
      action: 'click',
      category: 'application-save',
      description: 'open save application',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        currentFormStep: formStepper.step + 1,
        value: 'save_application',
      },
    };
    Report(eventInfo, userId, submitionId);

    dispatch(saveSubmition(data));
    setSaveProcess(true);
  };

  const closeSave = () => {
    setSaveProcess(false);
  };

  const doWholeProcess = async () => {
    const formData = { ...submitionData, completeProcess: true };
    handleNext(formData);
  };

  const resetProcess = () => {
    dispatch(resetSubmition());
    dispatch(resetData());
    dispatch(resetSteps());
    dispatch(resetUser());
  };

  const onSaveAndExit = async (data, user) => {
    const eventInfo = {
      action: 'click',
      category: 'save_application',
      description: 'clicked save and exit',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        currentFormStep: formStepper.step + 1,
        value: `save_exit_application`,
      },
    };
    Report(eventInfo, userId, submitionId);

    setExit(true);
    const formSectionSlug = formStepperSteps[formStepper.step].slug;
    const step = formStepperSteps.findIndex((x) => x.slug === formSectionSlug);

    let submition = data;

    dispatch(saveSubmition(submition));

    if (user) {
      try {
        if (!submition._id) {
          //Create Submition
          await dispatch(
            createSubmition({
              ...submition,
            })
          )
            .unwrap()
            .then(() => {
              resetProcess();
              navigate('/');
            })
            .catch(() => {});
        } else {
          await dispatch(
            updateSubmition({
              ...submition,
              submitionId: submition._id,
            })
          )
            .unwrap()
            .then(() => {
              resetProcess();
              navigate('/');
            })
            .catch(() => {});
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      setSaveProcess(true);
    }
  };

  const completedFormSteps = () => {
    return formStepperSteps.filter((s) => s.completed).length;
  };

  const handleNext = async (props) => {
    // Redux formStepper.step is the source of truth for the
    // form step the user is actually currently on.
    const currentStepIndex = formStepper.step;
    const currentStep = formStepperSteps[currentStepIndex];

    if (!currentStep) {
      console.error('Could not find current form step:', currentStepIndex);
      return;
    }

    const currentStepSlug = currentStep.slug;
    const newStep = currentStepIndex + 1;

    // Keep stepSlug out of the data that gets saved.
    const { stepSlug, ...submissionData } = props;

    const submition = {
      ...submissionData,
      activeStepperStep: stepper.active,
      activeFormStep: currentStepIndex,
    };

    const eventInfo = {
      action: 'click',
      category: 'guidance',
      description: 'clicked continue / save and continue',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        completedFormSteps: completedFormSteps() + 1,
        currentFormStep: formStepper.step + 1,
        value: userId ? 'save_and_continue' : 'continue',
      },
    };

    Report(eventInfo, userId, submitionId);

    await dispatch(saveSubmition(submition));

    try {
      if (data.funds) {
        if (!submition._id) {
          await dispatch(
            createSubmition({
              ...submition,
              ...data,
            })
          )
            .unwrap()
            .then((originalPromiseResult) => {
              if (originalPromiseResult.submitionId) {
                if (submition.completeProcess) {
                  dispatch(createSecureProcess(originalPromiseResult.submitionId))
                    .unwrap()
                    .catch(() => {
                      dispatch(updateStep(3));
                      navigate(thisStep.url);
                    });
                } else {
                  console.log('Changing form step to:', newStep);
                  console.log(
                    'Completing form step:',
                    currentStepSlug,
                    'at index:',
                    currentStepIndex
                  );

                  dispatch(changeStep(newStep));
                  dispatch(completeFormStep(currentStepSlug));
                }
              }
            })
            .catch(() => {
              dispatch(updateStep(3));
              navigate(thisStep.url);
            });
        } else {
          await dispatch(
            updateSubmition({
              ...submition,
              ...data,
              submitionId: submition._id,
            })
          )
            .unwrap()
            .then((originalPromiseResult) => {
              if (originalPromiseResult.submitionId) {
                if (submition.completeProcess) {
                  dispatch(createSecureProcess(originalPromiseResult.submitionId))
                    .unwrap()
                    .catch(() => {
                      dispatch(updateStep(3));
                      navigate(thisStep.url);
                    });
                } else {
                  dispatch(changeStep(newStep));
                  dispatch(completeFormStep(currentStepSlug));
                }
              }
            })
            .catch(() => {
              dispatch(updateStep(3));
              navigate(thisStep.url);
            });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBack = () => {
    const newStep = formStepper.step - 1;
    const eventInfo = {
      action: 'click',
      category: 'guidance',
      description: 'back in form stepper',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        currentFormStep: formStepper.step + 1,
        value: `back`,
      },
    };
    Report(eventInfo, userId, submitionId);
    dispatch(changeStep(newStep));
  };

  const displaySection = (slug) => {
    switch (slug) {
      case 'contact_information':
        return {
          label: 'Contact Information',
          component: (
            <ContactInfo
              openSave={openSave}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              onNext={handleNext}
              onSaveAndExit={onSaveAndExit}
              isRaHelp={isRaHelp}
              isBciApplication={isBciApplication}
              stepSlug="contact_information"
            />
          ),
        };
      case 'personal_information':
        return {
          label: 'Personal Information',
          component: (
            <PersonalDetails
              openSave={openSave}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              onNext={handleNext}
              onBack={handleBack}
              isRaHelp={isRaHelp}
              isBciApplication={isBciApplication}
              isApexRihfOrQihf={isApexRihfOrQihf}
              onSaveAndExit={onSaveAndExit}
              stepSlug="personal_information"
            />
          ),
        };
      case 'beneficiaries_nominations':
        return {
          label: 'Beneficiaries Nominations',
          component: (
            <BeneficiariesNominations
              openSave={openSave}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              isBciApplication={isBciApplication}
              onNext={handleNext}
              onBack={handleBack}
              onSaveAndExit={onSaveAndExit}
              isRaHelp={isRaHelp}
              stepSlug="beneficiaries_nominations"
            />
          ),
        };
      case 'investment_details':
        return {
          label: 'Investment Details',
          component: (
            <InvestmentDetails
              openSave={openSave}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              isBciApplication={isBciApplication}
              onNext={handleNext}
              onBack={handleBack}
              onSaveAndExit={onSaveAndExit}
              isRaHelp={isRaHelp}
              stepSlug="investment_details"
            />
          ),
        };
      case 'banking_and_payment':
        return {
          label: 'Banking & Payments',
          component: (
            <BankingDetails
              openSave={openSave}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              isBciApplication={isBciApplication}
              isApexRihfOrQihf={isApexRihfOrQihf}
              onNext={handleNext}
              onBack={handleBack}
              onSaveAndExit={onSaveAndExit}
              isRaHelp={isRaHelp}
              stepSlug="banking_and_payment"
            />
          ),
        };
      case 'regular_withdrawals':
        return {
          label: 'Regular Withdrawals',
          component: (
            <RegularWithdrawalsDetails
              openSave={openSave}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              isBciApplication={isBciApplication}
              onNext={handleNext}
              onBack={handleBack}
              onSaveAndExit={onSaveAndExit}
              stepSlug="regular_withdrawals"
            />
          ),
        };
      case 'tax_details':
        return {
          label: 'Tax Details',
          component: (
            <TaxResidencySelfCerificationDetails
              openSave={openSave}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              isBciApplication={isBciApplication}
              onNext={handleNext}
              onBack={handleBack}
              onSaveAndExit={onSaveAndExit}
              isRaHelp={isRaHelp}
              stepSlug="tax_details"
            />
          ),
        };
      case 'required_documents':
        return {
          label: 'Required Documentation',
          component: (
            <RequiredDocumentation
              openSave={openSave}
              submitionId={submitionId}
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              isBciApplication={isBciApplication}
              onNext={handleNext}
              onBack={handleBack}
              onSaveAndExit={onSaveAndExit}
              stepSlug="required_documents"
            />
          ),
        };
      case 'review_and_submit':
        return {
          label: 'Review And Submit',
          component: (
            <ReviewAndSubmit
              extendedForm={extendedForm}
              data={data}
              submitionData={submitionData}
              onNext={handleNext}
              onBack={handleBack}
            />
          ),
        };
      default:
        return null;

      //  extendedForm  && {
      //     label: "Dividend Withholding Tax Declaration (DWT)",
      //     description: DividendWithholdingTaxDeclarationDetails({ extendedForm }),
      //   },
    }
  };

  const FormSectionStepper = (props) => {
    return (
      <Box className={classes.root}>
        <Stepper activeStep={formStepper.step} orientation="vertical">
          {props.map(
            (step, index) =>
              step && (
                <Step key={index} completed={step.completed}>
                  <StepButton
                    disabled={false}
                    onClick={() => {
                      dispatch(changeStep(index));
                    }}
                  >
                    <Typography variant="h4" color="primary">
                      {displaySection(step.slug).label}
                    </Typography>
                  </StepButton>
                  <StepContent>{displaySection(step.slug).component}</StepContent>
                </Step>
              )
          )}
        </Stepper>
      </Box>
    );
  };
  const stepperContent = () => {
    return (
      <Box>
        {' '}
        <SaveProcess
          saveAndExit={exit}
          open={saveProcess}
          openSave={() => openSave()}
          closeSave={() => closeSave()}
        />
        {FormSectionStepper(formStepperSteps)}
      </Box>
    );
  };
  return (
    <>
      <InvestNowStepper
        selectedStep={2}
        getStepContent={() => stepperContent()}
        checkValidation={() => true}
        nextAltText={'Submit'}
        onNext={() => doWholeProcess()}
        // onPrev={() => }
      />
    </>
  );
}

export default Details;
